import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  input: {
    opacity: 0,
  },
  text: {
    fontWeight: 'normal',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: '1rem',
    marginRight: pxToRem(4),
  },
});
